import { configureStore } from "@reduxjs/toolkit";

// Importing reducers
import { reducer as reduxFormReducer } from "redux-form";
import appReducer from './app/appSlice';
import authReducer from './features/auth/authSlice'
import appNavConfigReducer from './app/appNavConfigSlice'
import userRegistrationReducer from "./features/home/user-registration/userRegistrationSlice";
import partnerIDReducer from './features/partner-id/partnerIDSlice'
import loyaltySideNavReducer from './features/loyalty/loyaltySideNavSlice'
import viewRedeemableSerialReducer from './features/loyalty/my-loyalty/view-redeemable-serial/viewRedeemableSerialSlice'
import claimedHistoryReducer from './features/loyalty/my-loyalty/claimed-history/claimedHistorySlice'


const store = configureStore({

    reducer: {
        form: reduxFormReducer,
        app: appReducer,
        auth: authReducer,
        appNavConfig: appNavConfigReducer,
        userRegistration:userRegistrationReducer,
        partnerID:partnerIDReducer,
        loyaltySideNav: loyaltySideNavReducer,
        viewRedeemableSerial: viewRedeemableSerialReducer,
        claimedHistory: claimedHistoryReducer

    },
    devTools: true

})

export default store;
